/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useHistory } from "react-router-dom";
import { validate } from "uuid";

export function useUuidValidator(id: string) {
  const history = useHistory();

  React.useEffect(() => {
    if (validate(id) === false) {
      history.replace("/404");
    }
  }, [history, id]);
}
